<template>
    <div class="theFotter">
        <!-- <div class="center">
            <p>
                <span>使用条款</span>
                <span>货物追踪</span>
                <span>价格时效</span>
                <span>网点查询</span>
                <span>壹起购</span>
                <span>开放平台</span>
                <span>隐私政策</span>
            </p>
        </div> -->
        <div class="copy">
            <p>Copyright © 2015-2020 壹米滴答供应链集团有限公司. All rights reserved. <a href="http://www.miitbeian.gov.cn/">沪ICP备15046748号</a> <img src="../../assets/images/beian.png" /> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?COLLCC=3484918587&recordcode=31011802001324">沪公网安备 42011202000156号</a></p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    created() {},
    methods: {}
};
</script>
<style scoped lang="scss">
.theFotter {
    width: 100%;
    height: 56px;
    background-color: #221814;
    border-bottom: 1px solid #383838;
    .center {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        max-width: 1200px;
        height: 56px;
        font-size: 14px;
        background-color: #221814;
        overflow: hidden;
        text-align: center;
        border-bottom: 1px solid #383838;
        span {
            cursor: pointer;
            color: #c6c6c6;
            margin: 0 33px;
            line-height: 57px;
        }
    }
    .copy {
        font-size: 13px;
        height: 52px;
        background-color: #221814;
        line-height: 57px;
        color: #c6c6c6;
        text-align: center;
        img {
            margin: -5px 6px;
        }
        a {
            color: #c6c6c6;
        }
        a:hover {
            color: #fabe00;
        }
    }
}
</style>
